<template>
  <div class="product-media" :class="playerClass">
    <div class="product-media__player" v-if="isPlaceholderPresent && isVideoPresent" @click="play">
      <span class="icon-player product-media__icon"></span>
      <video
        width="250"
        height="250"
        ref="videoEl"
        :poster="placeholder ? baseUrlMedia + placeholder.fileId + '/' + placeholder.fileName + '?width=375' : ''"
        @ended="onEnd"
      >
        <source :src="video ? baseUrlMedia + video.fileId + '/' + video.fileName : ''" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="product-media__player" v-else-if="isVideoPresent" @click="play">
      <span class="icon-player product-media__icon"></span>
      <video width="250" height="250" ref="videoEl" @ended="onEnd">
        <source :src="video ? baseUrlMedia + video.fileId + '/' + video.fileName : ''" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
    <div class="product-media__player product-media__player_poster" v-else-if="isPlaceholderPresent">
      <img
        :src="placeholder ? baseUrlMedia + placeholder.fileId + '/' + placeholder.fileName + '?width=375' : ''"
        :alt="alt"
        @load="onImgLoad"
        class="product-media__image"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useMainStore } from '@/stores/main';

  interface MediaItem {
    fileId?: string;
    fileName?: string;
    external?: {
      title?: string;
    };
    title?: string;
  }

  const props = defineProps<{
    placeholder?: MediaItem;
    video?: MediaItem;
  }>();

  const mainStore = useMainStore();
  const baseUrlMedia = computed(() => mainStore.baseUrlMedia);

  const playerClass = ref('');
  const videoEl = ref<HTMLVideoElement | null>(null);

  const emit = defineEmits<{
    imageLoaded: [];
  }>();

  function setProperFieldExternalFirst(obj: MediaItem | undefined, field: string): string {
    return obj && obj.external && obj.external[field as keyof typeof obj.external]
      ? (obj.external[field as keyof typeof obj.external] as string)
      : obj && obj[field as keyof MediaItem]
        ? (obj[field as keyof MediaItem] as string)
        : '';
  }

  const alt = computed(() => setProperFieldExternalFirst(props.placeholder, 'title'));
  const isPlaceholderPresent = computed(() => props.placeholder && props.placeholder.fileId && props.placeholder.fileName);
  const isVideoPresent = computed(() => props.video && props.video.fileId && props.video.fileName);

  function play() {
    playerClass.value = 'playing';
    if (videoEl.value) videoEl.value.play();
  }
  function onEnd() {
    playerClass.value = '';
  }
  function onImgLoad() {
    emit('imageLoaded');
  }
</script>
